import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as Arrow } from "../../assets/img/Arrowdown.svg";
import { toast } from "react-toastify";
import api from "api";

const CustomSelect = ({ options, status, item, getOrders, onApproveStart }) => {
    const defaultOption = options.find(option => option.value === status) || options[0]; // Default to given status or first option
    const [selected, setSelected] = useState(defaultOption);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const isEditable = status === "pending" || !status; // Enable if status is "pending" or not provided
    const pendingBatch = item.batchIds.find(batch => batch.status === "pending");


    const handleValidateAPI = (selectedOption, batchId, orderId,) => {
        if (selectedOption.value === "pending") {
            toast.error("Order is in pending state")
            setIsOpen(false);
        }
        if (!batchId) {
            toast.error("No Batch Found")
            setIsOpen(false);
        }
        if (!orderId) {
            return toast.error("No Order Found")
        }
        // requestApproveLoading
        if (selectedOption.value === "approved") {
            api("patch", `/requests/approveOrderRequest/${batchId}`)
                .then((res) => {
                    toast.success(res.message || "Code generation started")
                    setSelected(selectedOption);
                    setIsOpen(false);
                    // Trigger progress tracking in parent
                    if (onApproveStart) {
                        onApproveStart(batchId);
                    } else {
                        getOrders();
                    }
                })
                .catch(() => {
                    setIsOpen(false);
                    toast.error("Failed to approve batch");
                });
        }


    }

    const toggleDropdown = () => {
        if (isEditable) {
            setIsOpen(!isOpen);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    useEffect(() => {
        setSelected(defaultOption)
    }, [status])

    return (
        <div ref={dropdownRef} style={{ position: "relative", width: "95px", fontFamily: "Outfit" }}>
            <div
                className={`select-selected d-flex justify-content-between align-items-center ${isOpen ? "select-arrow-active" : ""}`}
                style={{
                    gap: "6px",
                    backgroundColor: isEditable ? "white" : "#f5f5f5",
                    color: isEditable ? "#000" : "#ccc",
                    border: "1px solid #E4E4E4",
                    padding: "5px 10px",
                    borderRadius: "6px",
                    cursor: isEditable ? "pointer" : "not-allowed",
                    position: "relative",
                    fontSize: "13px",
                }}
                onClick={toggleDropdown}
            >
                {selected.label}
                <span
                    style={{
                        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "0.3s",
                        pointerEvents: isEditable ? "auto" : "none",
                        display: "flex",
                    }}
                >
                    <Arrow style={{ width: 12, height: 12 }} />
                </span>
            </div>
            {isOpen && (
                <div
                    className="select-items"
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        backgroundColor: "white",
                        border: "1px solid #E4E4E4",
                        zIndex: 99,
                        borderRadius: "0 0 6px 6px",
                        borderTop: 0,
                    }}
                >
                    {options
                        .filter(option => option.value !== "processed" && option.value !== "pending")
                        .map((option) => (
                            <div
                                key={option.value}
                                onClick={() => handleValidateAPI(option, pendingBatch?._id, item._id)}
                                style={{
                                    color: "black",
                                    padding: "5px 10px",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                }}
                                className="option-item"
                            >
                                {option.label}
                            </div>
                        ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
